import Vue from 'vue';

// MI
import MiButton from '@/components/mi-button/MiButton';
import MiDialog from '@/components/mi-dialog/MiDialog';
import MiFileUpload from '@/components/mi-file-upload/MiFileUpload';
import MiGlobalSearch from '@/components/mi-global-search/MiGlobalSearch';
import MiLogs from '@/components/mi-logs/MiLogs';
import MiPassword from '@/components/mi-password/MiPassword';

// GENERAL
import ActionDeleteIcon from '@/components/action-icon/action-delete-icon/ActionDeleteIcon';
import ActionList from '@/components/ActionList/ActionList';
import Autocomplete from '@/components/Autocomplete/Autocomplete';
import BrandFilter from '@/components/CustomFilter/BrandFilter/BrandFilter.vue';
import CreateDialogHeader from '@/components/CreateDialogHeader/CreateDialogHeader.vue';
import DataTable from '@/components/data-table/DataTable';
import DatePicker from '@/components/DatePicker/DatePicker';
import DateFilter from '@/components/CustomFilter/DateFilter/DateFilter.vue';
import DialogLayoutFull from '@/components/DialogLayoutFull/DialogLayoutFull.vue';
import DialogLayoutFullSteps from '@/components/DialogLayoutFullSteps/DialogLayoutFullSteps.vue';
import FilterMultipleLayout from '@/components/FilterMultipleLayout/FilterMultipleLayout.vue'
import ImageCollection from '@/components/ImageCollection/ImageCollection';
import LabelValue from '@/components/LabelValue.vue';
import LoaderCard from '@/components/loader-card/LoaderCard';
import MaiaChat from '@/components/MaiaChat/MaiaChat.vue';
import Pill from '@/components/Pill/Pill.vue';
import StepperHeader from '@/components/StepperHeader/StepperHeader.vue';
import TabLabels from '@/components/TabLabels/TabLabels.vue';
import Title from '@/components/Title/Title.vue';
import UploadCsvErrorRecord from '@/components/UploadCsvErrorRecord/UploadCsvErrorRecord.vue';
import UploadCsvSuccessRecord from '@/components/UploadCsvSuccessRecord/UploadCsvSuccessRecord.vue';

// VUE-UI COMPONENTS CUSTOMISED FOR MAISON
import ASelectInput from '@/components/ASelectInput/ASelectInput.vue';

// CUSTOM: AUTOCOMPLETE
import BrandAutocomplete from '@/components/CustomAutocomplete/BrandAutocomplete/BrandAutocomplete.vue';
import CategoryAutocomplete from '@/components/CategoryAutocomplete/CategoryAutocomplete.vue';
import ColourAutocomplete from '@/components/ColourAutocomplete/ColourAutocomplete.vue';
import MasterDataStatusAutocomplete from '@/components/CustomAutocomplete/MasterDataStatusAutocomplete/MasterDataStatusAutocomplete.vue';
import OrderStatusAutocomplete from '@/components/CustomAutocomplete/OrderStatusAutocomplete/OrderStatusAutocomplete.vue';
import ProductAutocomplete from '@/components/CustomAutocomplete/ProductAutocomplete/ProductAutocomplete.vue';
import ProductVariantAutocomplete from '@/components/CustomAutocomplete/ProductVariantAutocomplete/ProductVariantAutocomplete.vue';
import SizeAutocomplete from '@/components/CustomAutocomplete/SizeAutocomplete/SizeAutocomplete.vue';
import SupplierAutocomplete from '@/components/CustomAutocomplete/SupplierAutocomplete/SupplierAutocomplete.vue';
import SupplierSizeAutocomplete from '@/components/CustomAutocomplete/SupplierSizeAutocomplete/SupplierSizeAutocomplete.vue';
import SupplierSizePackAutocomplete from '@/components/CustomAutocomplete/SupplierSizePackAutocomplete/SupplierSizePackAutocomplete.vue';

// CUSTOM: CARD
import CreatePurchaseOrderCard from '@/components/CustomCard/CreatePurchaseOrderCard/CreatePurchaseOrderCard.vue';
import CreatePurchaseOrderItemCard from '@/components/CustomCard/CreatePurchaseOrderItemCard/CreatePurchaseOrderItemCard.vue';
import EditPurchaseOrderItemCard from '@/components/CustomCard/EditPurchaseOrderItemCard/EditPurchaseOrderItemCard.vue';

// CUSTOM: EDITABLE CARD
import PurchaseOrderEditableCard from '@/components/CustomEditableCard/PurchaseOrderEditableCard/PurchaseOrderEditableCard.vue';

// CUSTOM: DATATABLE
import GoodsInDatatable from '@/components/CustomDatatable/GoodsInDatatable/GoodsInDatatable';
import MediaDatatable from '@/components/CustomDatatable/MediaDatatable/MediaDatatable';
import ProductVariantDatatable from '@/components/CustomDatatable/ProductVariantDatatable/ProductVariantDatatable';
import PurchaseOrderDatatable from '@/components/CustomDatatable/PurchaseOrderDatatable/PurchaseOrderDatatable';
import PurchaseOrderItemDatatable from '@/components/CustomDatatable/PurchaseOrderItemDatatable/PurchaseOrderItemDatatable';
import PurchaseOrderOrderSummaryDatatable from '@/components/CustomDatatable/PurchaseOrderOrderSummaryDatatable/PurchaseOrderOrderSummaryDatatable';

// CUSTOM: DIALOG
import AddProductAttributesDialog from '@/components/CustomDialog/AddProductAttributesDialog/AddProductAttributesDialog.vue';
import BulkUpdatePurchaseOrderItemsDialog from '@/components/CustomDialog/BulkUpdatePurchaseOrderItemsDialog/BulkUpdatePurchaseOrderItemsDialog.vue';
import CreatePurchaseOrderDialog from '@/components/CustomDialog/CreatePurchaseOrderDialog/CreatePurchaseOrderDialog.vue';
import EditPurchaseOrderItemDialog from '@/components/CustomDialog/EditPurchaseOrderItemDialog/EditPurchaseOrderItemDialog.vue';
import QuickAddProductsDialog from '@/components/CustomDialog/QuickAddProductsDialog/QuickAddProductsDialog.vue';
import UploadMediaDialog from '@/components/CustomDialog/UploadMediaDialog/UploadMediaDialog.vue';
import UploadPurchaseOrderItemsCsvDialog from '@/components/CustomDialog/UploadPurchaseOrderItemsCsvDialog/UploadPurchaseOrderItemsCsvDialog.vue';

// CUSTOM: FILTER
import MasterDataStatusFilter from '@/components/CustomFilter/MasterDataStatusFilter/MasterDataStatusFilter.vue';
import OrderStatusFilter from '@/components/CustomFilter/OrderStatusFilter/OrderStatusFilter.vue';
import SeasonFilter from '@/components/CustomFilter/SeasonFilter/SeasonFilter.vue';
import SupplierFilter from '@/components/CustomFilter/SupplierFilter/SupplierFilter.vue';

// CUSTOM: FILTERS
import ProductFilters from '@/components/CustomFilters/ProductFilters/ProductFilters.vue';
import PurchaseOrderFilters from '@/components/CustomFilters/PurchaseOrderFilters/PurchaseOrderFilters.vue';
import VariantFilters from '@/components/CustomFilters/VariantFilters/VariantFilters.vue';

// CUSTOM: SELECT
import CreateOrPrefillFromProductSelect from '@/components/CustomSelect/CreateOrPrefillFromProductSelect/CreateOrPrefillFromProductSelect.vue';

// CUSTOM: STEPS
import AddProductAttributesAttributesStep from '@/components/CustomStep/AddProductAttributesAttributesStep/AddProductAttributesAttributesStep.vue';
import AddProductAttributesOverviewStep from '@/components/CustomStep/AddProductAttributesOverviewStep/AddProductAttributesOverviewStep.vue';
import AddProductAttributesSuccessStep from '@/components/CustomStep/AddProductAttributesSuccessStep/AddProductAttributesSuccessStep.vue';
import AddProductAttributesVariantsStep from '@/components/CustomStep/AddProductAttributesVariantsStep/AddProductAttributesVariantsStep.vue';

// CUSTOM: TEXT INPUT
import SupplierColorTextInput from '@/components/CustomTextInput/SupplierColorTextInput/SupplierColorTextInput.vue';
import SupplierSizeTextInput from '@/components/CustomTextInput/SupplierSizeTextInput/SupplierSizeTextInput.vue';
import SupplierSizeTextInputOld from '@/components/CustomTextInput/SupplierSizeTextInputOld/SupplierSizeTextInputOld.vue';

// MI
// import MiBugTracker from '@/components/mi-bug-tracker/MiBugTracker';
// import MiInbox from '@/components/mi-inbox/MiInbox';
// Vue.component('mi-bug-tracker', MiBugTracker);
// Vue.component('mi-inbox', MiInbox);
Vue.component('mi-dialog', MiDialog);
Vue.component('mi-global-search', MiGlobalSearch);
Vue.component('mi-logs', MiLogs);
Vue.component('mi-password', MiPassword);
Vue.component('MiButton', MiButton);
Vue.component('MiFileUpload', MiFileUpload);

// GENERAL
Vue.component('ActionDeleteIcon', ActionDeleteIcon);
Vue.component('ActionList', ActionList);
Vue.component('Autocomplete', Autocomplete);
Vue.component('CreateDialogHeader', CreateDialogHeader);
Vue.component('DataTable', DataTable);
Vue.component('DatePicker', DatePicker);
Vue.component('DateFilter', DateFilter);
Vue.component('DialogLayoutFull', DialogLayoutFull);
Vue.component('DialogLayoutFullSteps', DialogLayoutFullSteps);
Vue.component('FilterMultipleLayout', FilterMultipleLayout);
Vue.component('ImageCollection', ImageCollection);
Vue.component('Pill', Pill);
Vue.component('LabelValue', LabelValue);
Vue.component('LoaderCard', LoaderCard);
Vue.component('MaiaChat', MaiaChat);
Vue.component('StepperHeader', StepperHeader);
Vue.component('TabLabels', TabLabels);
Vue.component('Title', Title);
Vue.component('UploadCsvErrorRecord', UploadCsvErrorRecord);
Vue.component('UploadCsvSuccessRecord', UploadCsvSuccessRecord);

// VUE-UI COMPONENTS CUSTOMISED FOR MAISON
Vue.component('ASelectInput', ASelectInput);

// CUSTOM: AUTOCOMPLETE
Vue.component('BrandAutocomplete', BrandAutocomplete);
Vue.component('CategoryAutocomplete', CategoryAutocomplete);
Vue.component('ColourAutocomplete', ColourAutocomplete);
Vue.component('OrderStatusAutocomplete', OrderStatusAutocomplete);
Vue.component('MasterDataStatusAutocomplete', MasterDataStatusAutocomplete);
Vue.component('ProductAutocomplete', ProductAutocomplete);
Vue.component('ProductVariantAutocomplete', ProductVariantAutocomplete);
Vue.component('SizeAutocomplete', SizeAutocomplete);
Vue.component('SupplierAutocomplete', SupplierAutocomplete);
Vue.component('SupplierSizeAutocomplete', SupplierSizeAutocomplete);
Vue.component('SupplierSizePackAutocomplete', SupplierSizePackAutocomplete);

// CUSTOM: CARD
Vue.component('CreatePurchaseOrderCard', CreatePurchaseOrderCard);
Vue.component('CreatePurchaseOrderItemCard', CreatePurchaseOrderItemCard);
Vue.component('EditPurchaseOrderItemCard', EditPurchaseOrderItemCard);

// CUSTOM: EDITABLE CARD
Vue.component('PurchaseOrderEditableCard', PurchaseOrderEditableCard);

// CUSTOM: DATATABLE
Vue.component('GoodsInDatatable', GoodsInDatatable);
Vue.component('MediaDatatable', MediaDatatable);
Vue.component('ProductVariantDatatable', ProductVariantDatatable);
Vue.component('PurchaseOrderDatatable', PurchaseOrderDatatable);
Vue.component('PurchaseOrderItemDatatable', PurchaseOrderItemDatatable);
Vue.component('PurchaseOrderOrderSummaryDatatable', PurchaseOrderOrderSummaryDatatable);

// CUSTOM: DIALOG
Vue.component('AddProductAttributesDialog', AddProductAttributesDialog);
Vue.component('BulkUpdatePurchaseOrderItemsDialog', BulkUpdatePurchaseOrderItemsDialog);
Vue.component('CreatePurchaseOrderDialog', CreatePurchaseOrderDialog);
Vue.component('EditPurchaseOrderItemDialog', EditPurchaseOrderItemDialog);
Vue.component('QuickAddProductsDialog', QuickAddProductsDialog);
Vue.component('UploadMediaDialog', UploadMediaDialog);
Vue.component('UploadPurchaseOrderItemsCsvDialog', UploadPurchaseOrderItemsCsvDialog);

// CUSTOM: FILTER
Vue.component('BrandFilter', BrandFilter);
Vue.component('MasterDataStatusFilter', MasterDataStatusFilter);
Vue.component('OrderStatusFilter', OrderStatusFilter);
Vue.component('SeasonFilter', SeasonFilter);
Vue.component('SupplierFilter', SupplierFilter);

// CUSTOM: FILTERS
Vue.component('ProductFilters', ProductFilters);
Vue.component('PurchaseOrderFilters', PurchaseOrderFilters);
Vue.component('VariantFilters', VariantFilters);

// CUSTOM: SELECT
Vue.component('CreateOrPrefillFromProductSelect', CreateOrPrefillFromProductSelect);

// CUSTOM: STEPS
Vue.component('AddProductAttributesAttributesStep', AddProductAttributesAttributesStep);
Vue.component('AddProductAttributesOverviewStep', AddProductAttributesOverviewStep);
Vue.component('AddProductAttributesSuccessStep', AddProductAttributesSuccessStep);
Vue.component('AddProductAttributesVariantsStep', AddProductAttributesVariantsStep);

// CUSTOM: TEXT INPUT
Vue.component('SupplierColorTextInput', SupplierColorTextInput);
Vue.component('SupplierSizeTextInput', SupplierSizeTextInput);
Vue.component('SupplierSizeTextInputOld', SupplierSizeTextInputOld);
